var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsMeeting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 296.869 296.869",
    style: {
      enableBackground: "new 0 0 296.869 296.869"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M291.06,79.663l-70.39-54.57c-4.525-3.509-10.651-4.135-15.791-1.615c-5.141,2.52-8.399,7.745-8.399,13.47v14.807h-70.701 c-8.284,0-15,6.716-15,15v49.527c0,8.284,6.716,15,15,15h70.701v14.808c0,5.725,3.259,10.95,8.399,13.47 c2.094,1.026,4.352,1.53,6.599,1.53c3.268,0,6.512-1.066,9.192-3.145l70.39-54.571c3.665-2.841,5.81-7.218,5.81-11.854 C296.869,86.881,294.725,82.504,291.06,79.663z",
    className: "symbol"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171.09,165.587h-70.701V150.78c0-5.725-3.259-10.95-8.399-13.47c-5.14-2.52-11.268-1.895-15.791,1.615L5.81,193.496 C2.145,196.337,0,200.714,0,205.351c0,4.637,2.145,9.014,5.81,11.854l70.389,54.571c2.681,2.079,5.925,3.146,9.192,3.146 c2.246,0,4.505-0.504,6.599-1.53c5.141-2.52,8.399-7.745,8.399-13.47v-14.808h70.701c8.284,0,15-6.716,15-15v-49.527 C186.09,172.303,179.374,165.587,171.09,165.587z",
    className: "symbol"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsMeeting);
export default __webpack_public_path__ + "static/media/arrows-meeting.460f25e7a72e6227661fd1f93bfe93d6.svg";
export { ForwardRef as ReactComponent };